<template lang="html">

  <section :class="['wordlist', {'loaded': loaded}, {'hintMode' : letterHintMode}]">
    <header>
      <h2>{{ title }}</h2>
      <span><strong>Words remaining:</strong> {{ remainingWords }} / {{ words.length }}</span>
    </header>
    <p v-if="letterHintMode" class="pe_wordlist_hint_header">Click a word below to show all the possible locations where it could start</p>
    <div class="clues">
      
      <ul         
        class="scroller"
      >
        <Word
          v-for="(word, i) in sortedWords"
          :key="`word-${i}`"
          :word="word"
          
        />
      </ul>
    </div>
  </section>

</template>

<script lang="js">

  import { mapState, mapGetters, mapActions } from 'vuex'
  import Word from './Word'

  export default  {
    name: 'wordlist',

    components: {
      Word
    },
    
    computed: {
      ...mapState({
        words: state => state.wordlist.words,
        title: state => state.wordlist.title,
        loaded: state => state.grid.loaded,
        letterHintMode: state => state.wordlist.letterHintMode,
      }),

      ...mapGetters({
        remainingWords: 'wordlist/remainingWords',
        sortedWords: 'wordlist/sortedWords',
      }),

    },
    methods: {
      highlightLetter(word){
        //console.log("Word to highlight is ", word)
      }
    }

  }
</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .wordlist {
    border: 1px solid #ececec;
    width: 20%;
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    background: var(--secondary-background-color);

    &.hintMode{
      background: var(--wordsearch-menu-light);
    }

    .pe_wordlist_hint_header{
      text-align: center;
      padding: 5px 5px;
      font-size: 0.8em;
    }
  
    @media (max-width: 868px) {
      width: 100%;
      margin-top: 0.5rem;
      display: block;
    }

    &:after {
      content:'';
      pointer-events: none;
      opacity: 1;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: #f5f5f5;
      transition: none;
    }

    &.loaded:after {
      opacity: 0;
      transition: opacity 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    
    header {
      display: flex;
      flex-direction: column;
      position: relative;
      border-bottom: 1px solid #ececec;
      align-items: flex-start;
      text-align: left;
      padding: 1rem;
      
      h2 {
        margin: 0 0 0.5rem;
        font-size: 1.2rem;
      }
      
      @media (max-width: 868px) {
        flex-direction: row;
        justify-content: space-between;

        h2 {
          margin: 0;
        }
      }
      
      @media (max-width: 600px) {
        padding: 0.6rem;

        h2 {
          font-size: 1rem;
        }

        strong {
          display: none;
        }
      }

    }

    // TODO this is the same as the cluelist
    .clues {
      position: relative;
      flex: 1;
      overflow: hidden;
      overflow-y: auto;

      @media (max-width: 868px) {
        height: 5em;
        display: block;
      }

      @media (max-width: 660px) {
        height: 7.1em;
      }

    }

    ul {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
      padding: 0.9rem;

      @media (max-width: 868px) {
        text-align: left;
        margin: 0.2rem;
        padding: 0rem;

        li {    
          margin: 0rem;
          display: inline-block;
        }
      }

    }


  }
</style>
